import { Component } from "react"

/* Components */
import { Tag } from "../../components"

/* Icons */
import { DealerIcon, KeyIcon } from "../../components/Icons"

/* Widgets */
import Layout from "./Layout"

/* REST API */
import { dealers, toggleDealer } from "../../api/Table"

/* Switch */
import Switch from "react-switch"

/* Swal */
import Swal from "../../helpers/alert"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../../translates/translate"

/* Helpers */
import { utils } from "../../helpers"



/* Widget Dealer */
class Dealer extends Component {

    constructor() {
        super()

        this.state = {
            status: "loading",
            data: [],
        }
    }

    componentDidMount = () => {
        this.load()
    }


    /* Load Dealers Data */
    load = (reload = false) => {

        /* Fields */
        const { uid } = this.props

        /* Check Params */
        if (!uid) {
            this.setState({ status: "error", data: [] })
            return
        }

        /* Refresh the page if necessary */
        if (reload) {
            this.setState({ status: "loading" })
        }

        /* START REST API */
        dealers({ uid }).then((response) => {
            if (response.status) {
                this.setState({ status: "ok", data: response.data })
            }
            else if (response.status === 401 || response.status === 403) {
                this.setState({ status: "permission", data: [] })
            }
            else if (response.status === 498) {
                this.setState({ status: "key", data: [] })
            }
            else {
                this.setState({ status: "error", data: [] })
            }
        }).catch(() => {
            this.setState({ status: "network", data: [] })
        })

    }



    /* Change Value */
    change = (dealer, status) => {

        /* Fields */
        const { uid, socket, isRoulette } = this.props
        const { data } = this.state

        /* Check Params */
        if (!uid) {
            Swal.fire(utils.notification(t("widget.unknownError"), "error"))
            return
        }

        toggleDealer({ uid, dealerID: dealer.id, status }).then((response) => {
            if (response.status === 200) {
                const dealers = data

                const index = dealers.findIndex((e) => parseInt(e.id) === parseInt(dealer.id))

                if (index > -1) {
                    dealers[index].enabled = status ? 1 : 0
                    this.setState({ data: dealers })

                    if (isRoulette) {
                        const activeDealers = dealers.filter((item) => item.enabled === 1).map(({ id, name, uid }) => ({ id, name, uid }))
                        socket.emit("rouletteDealers", activeDealers)
                    }

                }

                Swal.fire(utils.notification(status ? t("dealer.added") : t("dealer.removed"), "success"))
            }
            else if (response.status === 401 || response.status === 403) {
                Swal.fire(utils.notification(t("swal.noAccess"), "error"))
            }
            else if (response.status === 498) {
                Swal.fire(utils.notification(t("swal.invalidKey"), "error"))
            }
            else {
                Swal.fire(utils.notification(t("swal.generic"), "error"))
            }
        }).catch(() => {
            Swal.fire(utils.notification(t("swal.generic"), "error"))
        })

    }


    render = () => {

        /* Fields */
        const { status, data } = this.state

        /* Layout */
        if (status !== "ok") {
            return <Layout status={status} reload={() => this.load(true)} />
        }

        /* Enabled Dealers */
        const enabled = data.filter((item) => parseInt(item.enabled) === 1).length

        return (
            <div className="tbl--panel">

                <div className="tbl--section">

                    <div className="tbl--section-title">
                        <DealerIcon size={14} />
                        {t("game.dealers")}
                        <span className={`tbl--counter ${enabled === 0 ? "empty" : ""}`}>{enabled}/{data.length}</span>
                    </div>

                    {data.map((item, index) =>
                        <div className={`tbl--dealer ${parseInt(item.enabled) === 1 ? "active" : ""}`} key={`${index}`}>

                            <div className="tbl--dealer-avatar">
                                <DealerIcon size={18} />
                            </div>

                            <div className="tbl--dealer-text">
                                <h3>{item.name}</h3>
                                <p>{item.uid}</p>
                                <div className="tbl--dealer-pin">
                                    <KeyIcon size={12} />
                                    <Tag color="pink">{item.pincode}</Tag>
                                </div>
                            </div>

                            <Switch uncheckedIcon={false} checkedIcon={false} onColor="#8bc34a" onChange={(value) => this.change(item, value)} checked={parseInt(item.enabled) === 1} />

                        </div>
                    )}

                    {/* Empty List */}
                    {data.length === 0 && <div className="tbl--empty">{t("layout.empty")}</div>}

                </div>

            </div>
        )
    }

}

const mapStateToProps = (state) => ({
    language: state.language,
})

export default connect(mapStateToProps)(Dealer)